export default {
    defaultWfpTitle: "SPOC",
    defaultWfpTitlePassengers: "SPOC for Visitors",
    defaultWfpTitleFocalpoints: "SPOC for FPs",
    defaultChatTitle: "Chat with operator",
    defaultWfpHeaderPrivacy: 'The conversation will be saved for quality purposes. For more details, see the <a href="https://www.wfp.it/privacy/" target="_blank">privacy</a> section',
    defaultPrivacyMessage: `
    Hello,
    <br />
    please be informed that this chat uses an artificial intelligence system, in some cases generative, to respond accurately, quickly, and efficiently to your requests. Privacy notice at <a href="https://www.wfp.it/wfp-chat-privacy/" target="_blank">this link</a>.
    <br /><br />
    Additionally, to provide you with a personalized service and more effective responses via chatbot, do you authorize the processing of data provided within this conversation session?
  `,
    defaultWfpWelcomeMessagePassengers: `Hi! I'm Spoc, your virtual assistant. I'm here to support you throughout your accommodation journey and answer any questions along the way. I'll do my best to guide you.
    I'm AI powered, and every conversation helps me learn and improve.
    <strong>To ensure the best experience, please keep the chat open in just ONE tab.</strong><br/>
    How can I help you today?`,
    defaultWfpWelcomeMessageFocalpoints: `Hi, Focal Points, welcome! I'm Spoc, your virtual assistant.
    I'm here to support you on how to best use the Digital Office.
    If you're reaching out on behalf of a visitor, please access the chatbot from any UN Accommodation page outside the Digital Office.
    I'm AI-powered - your interactions help me continuously improve and provide better support.
    <strong>To ensure the best experience, please keep the chat open in just ONE tab.</strong><br/>
    How can I help you today?`,
    defaultTimeoutMessage: "Dear colleague, your conversation has been inactive for a while. Would you like to continue where you left or start a new question?",
    defaultConversationListHeading: "CONVERSATION LIST",
    defaultCasesHistoryHeading: "CASES HISTORY",
    defaultBackToConversationListLabel: "CHAT",
    defaultAskBotLabel: "Ask SPOC",
    defaultXmppConnectionMessage: "Thanks for your patience — the chat is loading and will be ready shortly. <br/> For the best experience, make sure the chatbot is open in just one browser window.",
    defaultSelectButtonLabel: "Select first a button to carry on",
    defaultInputTextPlaceholder: "Write your message",
    defaultInputDatePlaceholder: "Insert date",
    defaultInputLocationPlaceholder: "Insert location",
    defaultInputAutocompletePlaceholder: "Search choices",
    defaultPopupLocationPlaceholder: "write a position",
    defaultPopupButtonCancel: "Cancel",
    defaultPopupButtonConfirm: "Confirm",
    defaultTimeoutContinuePreviousMessage: "Continue",
    defaultTimeoutRestartMessage: "Start a new question",
    defaultRestartMessage: "New question",
    xmppErrorDefault: "Error during XMPP authentication",
    attachmentsErrorDefault: "An error occurred while uploading the file",
    attachmentsErrorNotFound: "No attachment was selected",
    attachmentsErrorExtensionNotAllowed: "The extension of the selected attachment is not supported (.jpg, .png, .gif, .tif, .doc, .docx, .pdf, .mp3, .zip, .rar)",
    attachmentsErrorFileTooBig: "The selected attachment is too large",
    attachmentsErrorInvalidConversation: "This is not a valid conversation for sending the selected attachment",
};
